var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qrcode-wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pup" },
      [
        _c(
          "el-popover",
          {
            attrs: {
              trigger: "click",
              title: "请打开手机微信，扫描下方二维码"
            },
            on: { show: _vm.handleFetchQrCode }
          },
          [
            _c(
              "el-skeleton",
              {
                staticStyle: { width: "240px" },
                attrs: { loading: !_vm.isInitial, animated: "" }
              },
              [
                _c(
                  "template",
                  { slot: "template" },
                  [
                    _c("el-skeleton-item", {
                      staticStyle: { width: "200px", height: "200px" },
                      attrs: { variant: "image" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                [
                  _c("div", [
                    _c("img", {
                      staticStyle: { width: "200px", height: "200px" },
                      attrs: { src: _vm.imageBase64 }
                    })
                  ])
                ]
              ],
              2
            ),
            _vm._v(" "),
            _c("svg-icon", {
              staticClass: "qrcode-svg",
              attrs: { slot: "reference", "icon-class": "qrcode" },
              slot: "reference"
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _c("span", [
        _vm._v("请务必关注公众号，否则不能及时接收有关通知；"),
        _c("br"),
        _vm._v("系统使用过程中遇到问题，也可在公众号中直接咨询。")
      ]),
      _vm._v(" "),
      _c("i", {
        staticClass: "el-icon-caret-right",
        staticStyle: {
          position: "absolute",
          right: "-14px",
          "font-size": "24px",
          color: "#FFFDD9",
          top: "50%",
          transform: "translateY(-50%)"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31224e5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31224e5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/QrCode.vue
// module id = null
// module chunks = 